import { jsx as _jsx } from "react/jsx-runtime";
import { List } from 'react-native-paper';
export const ResultOverview = (props) => {
    const onPress = async () => {
        if (props.onPress) {
            props.onPress(props.title);
        }
    };
    return (_jsx(List.Accordion, { title: props.title, expanded: props.expanded, onPress: onPress, children: props.children }));
};
